export default __webpack_public_path__ + "static/media/Poppinspoppins-boldsemibold.09c7d5a2.woff2";